<template>
  <form id="frm_action">
    <div class="p-formgrid property-sale-form">
      <Toolbar class="fixed-bottom-toolbar div-button css-button-top-right">
        <template slot="right">
          <Button
            label="Back"
            @click="backToList()"
            id="back"
            class="main-style-button"
            :disabled="isBusy"
          />
        </template>
      </Toolbar>

      <div class="col-12">
        <div class="p-card-field">
          <label class="p-col-fixed txt-right txt-required">Property</label>
          <div class="p-col">
            <v-select
              v-model="selectedProperty"
              :options="listProperty"
              label="display_name"
              placeholder="Choose"
              class="property-dropdown"
              :clearable="false"
              @input="changeProperty"
              :disabled="mode === 'edit'"
            >
              <span slot="no-options">
                Empty data
              </span>
            </v-select>
          </div>
        </div>
      </div>

      <div class="row col-12">
        <div class="col-6">
          <div class="p-card-field">
            <label class="p-col-fixed txt-right">Address</label>
            <div class="p-col">
              <InputText :value="currentProperty.address || ''" disabled />
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="p-card-field">
            <label class="p-col-fixed txt-right">Type of property</label>
            <div class="p-col">
              <InputText :value="currentProperty.property_type_name || ''" disabled />
            </div>
          </div>
        </div>
      </div>

      <div class="row col-12">
        <div class="col-4">
          <div class="p-card-field">
            <label class="p-col-fixed txt-right">Bedrooms</label>
            <div class="p-col">
              <InputText :value="currentProperty.bedroom || ''" disabled />
            </div>
          </div>
        </div>
        <div class="col-4">
          <div class="p-card-field">
            <label class="p-col-fixed txt-right">Bathrooms</label>
            <div class="p-col">
              <InputText :value="currentProperty.bathroom || ''" disabled />
            </div>
          </div>
        </div>
        <div class="col-4">
          <div class="p-card-field">
            <label class="p-col-fixed txt-right">Acreage (m2)</label>
            <div class="p-col">
              <InputText :value="currentProperty.acreage || ''" disabled />
            </div>
          </div>
        </div>
      </div>

      <div class="row col-12">
        <div class="col-6">
          <div class="p-card-field">
            <label class="p-col-fixed txt-right txt-required">Price</label>
            <div class="p-col">
              <div class="field-price">
                <InputNumber
                  v-model="form.price"
                  mode="decimal"
                  locale="vi-VN"
                  :useGrouping="true"
                  :minFractionDigits="0"
                  placeholder="Input"
                />
                <span class="field-price-suffix">€</span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="p-card-field">
            <label class="p-col-fixed txt-right">Extra information</label>
            <div class="p-col">
              <InputText v-model="form.extra_information" placeholder="Input" />
            </div>
          </div>
        </div>
      </div>

    

      <div class="col-12">
        <div class="p-card-field">
          <label class="p-col-fixed txt-right txt-required">Thumbnail</label>
          <div class="p-col">
            <div class="cus-text opacity-text-file">Size: 1200x900px Maximum: 10 MB</div>
            <div class="cus-text opacity-text-file">Attachments: JPG, JPEG, PNG, GIF.</div>
            <input class="p-inputtext p-component" accept="image/*" type="file" @change="onFileSelectThumbnail" />
            <small v-if="thumbnailRequiredError" class="p-error">Thumbnail is required</small>
            <div class="preview-list single">
              <div class="box-image" v-for="(item, index) in listThumbnail" :key="`thumb-${index}`">
                <img class="style_img" :src="item.objectURL" />
                <div class="button-clear" @click="removeThumbnail(index)">
                  <img src="/assets/images/icon/cancel_black_24dp.png" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="p-card-field">
          <label class="p-col-fixed txt-right txt-required">Images</label>
          <div class="p-col">
            <div class="cus-text opacity-text-file">Size: 150x100px Maximum: 10 MB</div>
            <div class="cus-text opacity-text-file">Attachments: JPG, JPEG, PNG, GIF.</div>
            <input class="p-inputtext p-component" accept="image/*" type="file" @change="onFileSelectImages" multiple />
            <small v-if="imageRequiredError" class="p-error">Images are required</small>
            <div class="preview-list">
              <div class="box-image" v-for="(item, index) in listImage" :key="`img-${index}`">
                <img class="style_img" :src="item.objectURL" />
                <div class="button-clear" @click="removeImage(index)">
                  <img src="/assets/images/icon/cancel_black_24dp.png" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      

      <Toolbar class="fixed-bottom-toolbar div-button">
        <template slot="right">
          <Button label="Cancel" @click.prevent="backToList" class="p-button-outlined" id="back" :disabled="isBusy" />
          <Button label="Save" @click.prevent="saveData" class="main-style-button" :loading="isBusy" :disabled="isBusy" />
        </template>
      </Toolbar>

      <Dialog
        :header="contactForm.id ? 'Edit contact' : 'Create contact'"
        :visible.sync="showContactDialog"
        :style="{width: '650px'}"
        :modal="true"
        :contentStyle="{ overflow: 'visible' }"
      >
        <div class="p-fluid contact-dialog-form">
          <div class="p-field-checkbox mb-3">
            <Checkbox v-model="contactForm.is_member" :binary="true" @change="changeMemberType" />
            <label class="ml-2">Five2one member</label>
          </div>

          <div v-if="contactForm.is_member">
            <div class="p-field">
              <label>User</label>
            <Dropdown
              v-model="contactForm.uid"
              :options="listUser"
              optionLabel="display_name"
              optionValue="id"
              placeholder="Choose"
              appendTo="body"
              class="contact-user-dropdown"
              panelClass="contact-user-dropdown-panel"
              :autoZIndex="true"
              :baseZIndex="12000"
              :filter="true"
              filterBy="display_name,search_text"
              @change="changeUser"
            />
            </div>
          </div>
          <div v-else>
            <div class="p-field">
              <label>Fullname</label>
              <InputText v-model="contactForm.fullname" placeholder="Input" />
            </div>
          </div>

          <div class="row">
            <div class="col-6">
              <div class="p-field">
                <label>Phone</label>
                <InputText v-model="contactForm.phone" placeholder="Input" :disabled="contactForm.is_member" />
              </div>
            </div>
            <div class="col-6">
              <div class="p-field">
                <label>Email</label>
                <InputText v-model="contactForm.email" placeholder="Input" :disabled="contactForm.is_member" />
              </div>
            </div>
          </div>

          <div class="p-field">
            <label>Contact date</label>
            <Calendar
              v-model="contactForm.contact_date"
              :showOnFocus="false"
              :showIcon="true"
              appendTo="body"
              dateFormat="MM dd, yy"
              showTime
              hourFormat="24"
              placeholder="Choose"
            />
          </div>

          <div class="p-field">
            <label>Note</label>
            <Textarea v-model="contactForm.note" rows="4" placeholder="Input" />
          </div>
        </div>
        <template #footer>
          <Button label="Cancel" @click="showContactDialog = false" class="p-button-outlined" />
          <Button label="Save" @click="saveContact" class="main-style-button" />
        </template>
      </Dialog>
    </div>
  </form>
</template>

<script>
import ApiRepository from "@/core/ApiRepository";
import moment from "moment-timezone";

export default {
  props: {
    mode: String,
    model: Object,
    isSaving: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: {
        id: null,
        property_id: null,
        price: null,
        extra_information: '',
        active: true,
      },
      listProperty: [],
      mapProperty: {},
      currentProperty: {},
      selectedProperty: null,
      listThumbnail: [],
      listImage: [],
      contacts: [],
      listUser: [],
      mapUser: {},
      showContactDialog: false,
      contactForm: {},
      isUploading: false,
      submittedSale: false,
      time_zone_local: moment.tz.guess(true),
    }
  },
  computed: {
    isBusy() {
      return this.isSaving || this.isUploading;
    },
    thumbnailRequiredError() {
      return this.submittedSale && this.listThumbnail.length < 1;
    },
    imageRequiredError() {
      return this.submittedSale && this.listImage.length < 1;
    },
  },
  watch: {
    model: {
      immediate: true,
      deep: true,
      handler(val) {
        this.listProperty = (val?.list_property ?? []).map(item => ({
          ...item,
          display_name: `${item.code || ''}${item.code && item.name ? ' - ' : ''}${item.name || ''}`,
        }));
        this.mapProperty = {};
        this.listProperty.forEach(item => {
          this.mapProperty[item.id] = item;
        });
        this.listUser = (val?.list_user ?? []).map(item => {
          const phoneFull = item?.phone_full ?? `${item?.prefix_phone ?? ''}${item?.phone ?? ''}`;
          return {
            ...item,
            phone_full: phoneFull,
            display_name: item?.display_name ?? [item?.fullname ?? '', item?.email ?? '', phoneFull]
              .filter(m => !this.$commonFuction.isEmpty(m))
              .join(' - '),
            search_text: item?.search_text ?? [item?.fullname ?? '', item?.email ?? '', phoneFull]
              .filter(m => !this.$commonFuction.isEmpty(m))
              .join(' ')
          };
        });
        this.mapUser = {};
        this.listUser.forEach(item => {
          this.mapUser[item.id] = item;
        });
        var post = val?.post ?? {};
        this.form = {
          id: post?.id ?? null,
          property_id: post?.property_id ?? null,
          price: post?.price ?? null,
          extra_information: post?.extra_information ?? '',
          active: post?.active !== false,
        };
        this.currentProperty = this.mapProperty[this.form.property_id] ?? {};
        this.selectedProperty = this.currentProperty?.id ? this.currentProperty : null;
        this.listThumbnail = (post?.thumbnail_files ?? []).map(item => ({...item}));
        this.listImage = (post?.image_files ?? []).map(item => ({...item}));
        this.contacts = (val?.contacts ?? []).map(item => ({...item}));
      }
    }
  },
  methods: {
    changeProperty() {
      this.form.property_id = this.selectedProperty?.id ?? null;
      this.currentProperty = this.mapProperty[this.form.property_id] ?? {};
    },
    makePreviewFiles(files = []) {
      var arrTemp = [];
      for (let file of files) {
        file.source = file;
        file.objectURL = window.URL.createObjectURL(file);
        arrTemp.push(file);
      }
      return arrTemp;
    },
    onFileSelectThumbnail(event) {
      let files = event.target.files || [];
      if (files.length > 0) {
        this.listThumbnail = this.makePreviewFiles([files[0]]);
      }
      event.target.value = null;
    },
    onFileSelectImages(event) {
      let files = event.target.files || [];
      if (files.length > 0) {
        this.listImage = this.listImage.concat(this.makePreviewFiles(files));
      }
      event.target.value = null;
    },
    removeThumbnail(index) {
      this.listThumbnail.splice(index, 1);
    },
    removeImage(index) {
      this.listImage.splice(index, 1);
    },
    async uploadAndNormalizeFiles(listFile = []) {
      var list_old = listFile.filter(item => item.type === 'old_edit' || item.id);
      var list_new = listFile.filter(item => item.type !== 'old_edit' && item.source);
      var list_result = list_old.map(item => ({
        id: item.id ?? item.file_id,
        file_id: item.file_id ?? item.id,
        url: item.url ?? item.objectURL,
        file_name: item.file_name ?? item.name ?? '',
      }));
      if (list_new.length > 0) {
        var resImage = await this.$CoreService.uploadImages(this.$constants.FOLDER_S3.PROPERTY_FOR_SALE, list_new);
        for (let i = 0; i < resImage.length; i++) {
          var itemImage = resImage[i];
          list_result.push({
            id: itemImage.id,
            file_id: itemImage.id,
            url: itemImage.url,
            file_name: itemImage.file_name ?? '',
          });
        }
      }
      return list_result;
    },
    async saveData() {
      if (this.isBusy) {
        return;
      }
      this.submittedSale = true;
      if (this.$commonFuction.isEmpty(this.form.property_id)) {
        this.$toast.add({ severity: 'error', summary: 'Error', detail: 'Property is required', life: 3000 });
        return;
      }
      if (this.$commonFuction.isEmpty(this.form.price) && this.form.price !== 0) {
        this.$toast.add({ severity: 'error', summary: 'Error', detail: 'Price is required', life: 3000 });
        return;
      }
      if (this.listThumbnail.length < 1) {
        this.$toast.add({ severity: 'error', summary: 'Error', detail: 'Thumbnail is required', life: 3000 });
        return;
      }
      if (this.listImage.length < 1) {
        this.$toast.add({ severity: 'error', summary: 'Error', detail: 'Images are required', life: 3000 });
        return;
      }
      try {
        this.isUploading = true;
        var thumbnail_files = await this.uploadAndNormalizeFiles(this.listThumbnail);
        var image_files = await this.uploadAndNormalizeFiles(this.listImage);
        this.$emit('save', {
          id: this.form.id,
          property_id: this.form.property_id,
          price: this.form.price,
          extra_information: this.form.extra_information,
          active: this.form.active,
          thumbnail_files,
          image_files,
        })
      } finally {
        this.isUploading = false;
      }
    },
    backToList() {
      if (this.isBusy) {
        return;
      }
      this.$emit('back')
    },
    formatDate(value) {
      if (this.$commonFuction.isEmpty(value)) {
        return '';
      }
      return moment.tz(value, this.time_zone_local).format('MMM DD, YYYY HH:mm:ss');
    },
    defaultContactForm() {
      return {
        id: null,
        post_id: this.form.id,
        is_member: false,
        uid: null,
        fullname: '',
        phone: '',
        email: '',
        contact_date: new Date(),
        note: '',
      };
    },
    openContactDialog(item = null) {
      this.contactForm = this.defaultContactForm();
      if (item) {
        this.contactForm = {
          id: item.id,
          post_id: item.post_id ?? this.form.id,
          is_member: item.is_member === true,
          uid: item.uid ?? null,
          fullname: item.fullname_display ?? item.fullname ?? '',
          phone: item.phone_display ?? item.phone ?? '',
          email: item.email_display ?? item.email ?? '',
          contact_date: item.contact_date ? new Date(item.contact_date) : new Date(),
          note: item.note ?? '',
        };
      }
      this.showContactDialog = true;
    },
    changeMemberType() {
      this.contactForm.uid = null;
      this.contactForm.fullname = '';
      this.contactForm.phone = '';
      this.contactForm.email = '';
    },
    changeUser() {
      var user = this.mapUser[this.contactForm.uid] ?? {};
      this.contactForm.fullname = user.fullname ?? '';
      this.contactForm.phone = user.phone_full ?? '';
      this.contactForm.email = user.email ?? '';
    },
    async saveContact() {
      try {
        const headers = {
          "Authorization": "Bearer " + (await this.$AuthenticationApp.getToken()),
        };
        await ApiRepository.post('/_api/property/save_property_for_sale_contact_admin', {
          ...this.contactForm,
          post_id: this.form.id,
        }, {headers});
        this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Saved contact successfully', life: 3000 });
        this.showContactDialog = false;
        this.$emit('refresh');
      } catch (err) {
        const error = err?.response?.data ?? null;
        this.$toast.add({ severity: 'error', summary: 'Error', detail: `Exception error [${error?.message || 'SAVE_CONTACT_FAILED'}]`, life: 3000 });
      }
    },
    async deleteContact(item) {
      try {
        const headers = {
          "Authorization": "Bearer " + (await this.$AuthenticationApp.getToken()),
        };
        await ApiRepository.post('/_api/property/delete_property_for_sale_contact_admin', {
          id: item.id,
        }, {headers});
        this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Deleted contact successfully', life: 3000 });
        this.$emit('refresh');
      } catch (err) {
        const error = err?.response?.data ?? null;
        this.$toast.add({ severity: 'error', summary: 'Error', detail: `Exception error [${error?.message || 'DELETE_CONTACT_FAILED'}]`, life: 3000 });
      }
    },
  },
}
</script>

<style lang="scss">
.property-sale-form {
  margin-top: -10px;

  &.p-formgrid {
    padding: 0 !important;
  }

  > .col-12 {
    margin-bottom: 0;
    padding-left: 15px !important;
    padding-right: 15px !important;
  }

  > .col-12,
  > .col-6,
  > .col-4 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }

  > .row.col-12 {
    margin: 0 !important;
    padding: 0 15px !important;
    display: flex;
    flex-wrap: nowrap;
    gap: 30px;
  }

  > .row.col-12 > .col-6,
  > .row.col-12 > .col-4 {
    padding: 0 !important;
  }

  > .row.col-12 > .col-6 {
    flex: 0 0 calc(50% - 15px);
    max-width: calc(50% - 15px);
  }

  > .row.col-12 > .col-4 {
    flex: 0 0 calc(33.333333% - 20px);
    max-width: calc(33.333333% - 20px);
  }

  .p-card-field {
    padding: 0 0 4px !important;
    margin-bottom: 0 !important;
  }

  .p-col-fixed,
  label {
    margin-bottom: 2px !important;
    line-height: 1.2;
    font-weight: 600;
  }

  :deep(.property-dropdown) {
    width: 100%;
  }

  :deep(.contact-user-dropdown) {
    width: 100%;
  }

  .field-price {
    display: flex;
    align-items: stretch;
    width: 100%;
  }

  .field-price :deep(.p-inputnumber) {
    flex: 1 1 auto;
  }

  .field-price :deep(.p-inputtext),
  .field-price :deep(.p-inputnumber-input) {
    width: 100%;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }

  .field-price-suffix {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 56px;
    padding: 0 12px;
    border: 1px solid #ced4da;
    border-left: 0;
    background: #e9ecef;
    color: #495057;
    border-top-right-radius: 3px;
    border-bottom-right-radius: 3px;
    font-size: 14px;
  }

  .div_check {
    padding-top: 0;
  }

  .checkbox {
    min-height: auto;
  }

  .cus-text {
    line-height: 1.35;
    margin-bottom: 0;
  }

  .preview-list {
    display: flex;
    gap: 12px;
    margin-top: 2px;
    flex-wrap: wrap;
  }

  .preview-list.single {
    min-height: 100px;
  }

  .box-image {
    position: relative;
    width: 100px;
    height: 100px;
  }

  .style_img {
    width: 100px;
    height: 100px;
    object-fit: cover;
    border-radius: 8px;
    border: 1px solid #D9E1EE;
  }

  .button-clear {
    position: absolute;
    top: -8px;
    right: -8px;
    cursor: pointer;
    background: #fff;
    border-radius: 50%;
  }

  .contact-section {
    border-top: 4px solid #F2F4F8;
    padding-top: 18px;
    margin-top: 8px;
  }

  .section-head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
  }

  .section-title {
    font-size: 18px;
    font-weight: 700;
    color: #2F3B52;
  }

  .contact-table-wrap {
    overflow-x: auto;
  }

  .contact-table {
    width: 100%;
    border-collapse: collapse;
  }

  .contact-table th,
  .contact-table td {
    border: 1px solid #D9E1EE;
    padding: 12px 10px;
    vertical-align: middle;
  }

  .contact-table th {
    background: #F4F7FB;
    text-align: center;
  }

  .action-cell {
    min-width: 110px;
    text-align: center;
  }

  .avatar-empty {
    width: 46px;
    height: 46px;
    border-radius: 50%;
    background: #E5EAF3;
  }

  .reply-empty {
    color: #7C889E;
  }

  .p-button-outlined {
    .p-button-label {
      color: #007ad9 !important;
    }
  }
}

:deep(.contact-user-dropdown-panel) {
  width: 480px !important;
  max-width: calc(100vw - 48px) !important;
  z-index: 12000 !important;
}
</style>
